module.exports = __webpack_public_path__ + "media/images/sazerac-logo-19088c01954874d8bf8b926396d1bfd4.svg";